import { Avatar, Box, Divider, Flex, SimpleGrid, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

import InfoField from "./InfoField";

interface ProfileData {
  workName: string;
  workRole: string;
  workId: string;
  workEmail: string;
  workPhone: string;
  centralPhone: string;
  profileImage?: string;
  personalName: string;
  privatePhone: string;
  privateEmail: string;
  startDate: string;
  birthDate: string;
  location: string;
  contractType: string;
  contactPerson: string;
  languages: string[];
}

interface ProfileHeaderProps {
  data: ProfileData;
}

const ProfileHeader = ({ data }: ProfileHeaderProps) => {
  const { t } = useTranslation();

  return (
    <Flex gap="xl" align="flex-start">
      {/* Leva strana - Slika i poslovni podaci */}
      <Flex gap={50} align="flex-start" mr="xl">
        <Avatar size={230} radius="50%" src={data.profileImage} />
        <Box>
          <Text fw={700} fz={28} mb={4}>
            {data.workName}
          </Text>
          <Text c="dark" fz={16} mb="lg">
            {data.workRole} | {data.workId}
          </Text>

          <InfoField label={t("profilePage.header.fields.workEmail")} value={data.workEmail} mb="md" />
          <InfoField label={t("profilePage.header.fields.workPhone")} value={data.workPhone} mb="md" />
          <InfoField label={t("profilePage.header.fields.centralPhone")} value={data.centralPhone} />
        </Box>
      </Flex>

      {/* Vertikalna linija */}
      <Divider orientation="vertical" mx="xl" />

      {/* Desna strana - Lični podaci */}
      <Box>
        <Text fw={700} fz={28} mb="lg">
          {data.personalName}
        </Text>

        <SimpleGrid cols={3} spacing="xl" verticalSpacing="lg">
          <InfoField label={t("profilePage.header.fields.privatePhone")} value={data.privatePhone} />
          <InfoField label={t("profilePage.header.fields.privateEmail")} value={data.privateEmail} />
          <InfoField label={t("profilePage.header.fields.startDate")} value={data.startDate} />
          <InfoField label={t("profilePage.header.fields.birthDate")} value={data.birthDate} />
          <InfoField label={t("profilePage.header.fields.location")} value={data.location} />
          <InfoField label={t("profilePage.header.fields.contractType")} value={data.contractType} />
          <InfoField label={t("profilePage.header.fields.contactPerson")} value={data.contactPerson} />
          <InfoField
            label={t("profilePage.header.fields.languages")}
            value={data.languages.map((lang, index) => (
              <div key={index}>{lang}</div>
            ))}
          />
        </SimpleGrid>
      </Box>
    </Flex>
  );
};

export default ProfileHeader;
